/**
 * GUARDIA LINGUA "APPICCICOSA" — fa sì che TUTTA l'app (vetrina + area riservata/CRM)
 * resti nella lingua scelta dall'utente, anche dopo atterraggi che perdono il prefisso
 * (es. login Google che porta su /admin, o un bookmark senza /es).
 *
 * Perché un modulo separato importato PER PRIMO:
 *   App.js sincronizza la lingua DALL'URL e riscrive `sila_lang` = lingua-URL a ogni
 *   caricamento (l'URL è la fonte di verità, SEO-corretto). Quindi non possiamo basarci
 *   su `sila_lang`. Usiamo invece una chiave DEDICATA `sila_lang_pref` che registra la
 *   SCELTA ESPLICITA dell'utente (impostata in goToLanguage) e NON viene mai sovrascritta.
 *   Questo modulo deve girare PRIMA di App: importandolo come primissima istruzione, il
 *   suo corpo viene eseguito prima delle side-effect di App.
 *
 * Comportamento:
 *   - Solo se la preferenza esplicita è 'en' o 'es' E l'URL è SENZA prefisso lingua,
 *     reindirizziamo (replace) alla versione localizzata (/es/... o /en/...).
 *   - Default IT (nessuna preferenza o 'it'): NESSUN redirect → zero cambiamenti.
 *   - Nessun loop: sugli URL già /en o /es la guardia non fa nulla.
 *
 * Sicurezza SEO/prerender: i crawler non hanno localStorage → nessuna preferenza →
 *   non vengono MAI reindirizzati. Il prerender non è toccato.
 */
export const LANG_PREF_KEY = 'sila_lang_pref';

try {
  if (typeof window !== 'undefined' && typeof localStorage !== 'undefined') {
    const pref = localStorage.getItem(LANG_PREF_KEY);
    if (pref === 'en' || pref === 'es') {
      const seg = (window.location.pathname || '/').split('/').filter(Boolean)[0];
      if (seg !== 'en' && seg !== 'es') {
        const p = (window.location.pathname || '/').replace(/\/+$/, '') || '/';
        const target = `/${pref}${p === '/' ? '' : p}${window.location.search || ''}${window.location.hash || ''}`;
        window.location.replace(target);
      }
    }
  }
} catch (e) {
  /* noop: in caso di errore restiamo sull'URL corrente */
}
